
import { defineComponent } from "vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";

export default defineComponent({
  components: {
    IntegerControl,
  },
  props: {
    model: { required: true },
  },
  methods: {},
  created(){
    this.modelLocal = this.model;
  },
  data(){
    return {
      modelLocal: null,
      weight: [{name: "cabinAxle", top: 345, left: 120},
        {name: "tractorFirstAxle", top: 345, left: 305}, 
        {name: "semitrailerFirstAxle", top: 345, left: 520},
        {name: "semitrailerSecondAxle", top: 345, left: 590},
        {name: "semitrailerThirdAxle", top: 345, left: 660}],
      distance: [{name: "tractorAxlesDistanceFirst", top: 152, left: 242, width: 40},
        {name: "tractorAxlesDistanceSecond", top: 152, left: 290, width: 40},
        {name: "semitrailerAxlesDistanceFirst", top: 152, left: 625, width: 56},
        {name: "tractorCabinAxlesDistance", top: 290, left: 210, width: 56},
        {name: "tractorSemitrailerAxlesDistance", top: 113, left: 420, width: 56}],
    };
  },
});
